import React, { useEffect, useId, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ContactRound, KeyRound, Save, X } from 'lucide-react'
import { tr } from 'i18n'
import ActorPinField from 'components/Erp/ActorPinField/ActorPinField.tsx'
import s from '../Management.module.scss'

type Props = { name: string; currentInn: string; mode: string; busy: boolean; error: string; onClose: () => void; onConfirm: (inn: string, pin: string) => void }

export default function GuardAccountDialog({ name, currentInn, mode, busy, error, onClose, onConfirm }: Props) {
  useTranslation()
  const titleId = useId()
  const [inn, setInn] = useState(currentInn)
  const [pin, setPin] = useState('')
  const form = useRef<HTMLFormElement>(null)
  const changingInn = mode === 'inn'
  const valid = /^[0-9]{4}$/.test(pin) && (!changingInn || /^[0-9]{14}$/.test(inn))
  useEffect(() => {
    const previous = document.activeElement as HTMLElement
    form.current?.focus()
    return () => previous?.focus()
  }, [])
  return <div className={s.overlay}>
    <form ref={form} tabIndex={-1} className={s.dialog} role="dialog" aria-modal="true" aria-labelledby={titleId}
      onKeyDown={event => { if (event.key === 'Escape' && !busy) onClose() }}
      onSubmit={event => { event.preventDefault(); if (valid && !busy) onConfirm(inn, pin) }}>
      <h2 id={titleId}>{changingInn ? <ContactRound size={20} aria-hidden="true" /> : <KeyRound size={20} aria-hidden="true" />}
        {tr(changingInn ? 'Смена ИНН охраны' : 'Сброс PIN охраны')}</h2>
      <p>{name}</p>
      {changingInn && <p>{tr('Текущий ИНН')}: <strong>{currentInn || '—'}</strong></p>}
      <p className={s.muted}>{tr(changingInn ? 'После изменения охранник входит по новому ИНН. PIN и пароль сохраняются.' : 'После сброса охранник задаст новый PIN при следующем входе.')}</p>
      {error && <div className={s.error} role="alert">{tr(error)}</div>}
      {changingInn && <>
        <label className={s.field}>{tr('Новый ИНН')}<input required inputMode="numeric" pattern="[0-9]{14}" maxLength={14}
          disabled={busy} value={inn} onChange={event => setInn(event.target.value.replace(/[^0-9]/g, '').slice(0, 14))} /></label>
        <p className={s.muted}>{tr('ИНН должен состоять из 14 цифр.')}</p>
      </>}
      <ActorPinField value={pin} onChange={setPin} disabled={busy} hint="Введите PIN своей учётной записи. PIN охранника не подходит." />
      <div className={s.footer}>
        <button type="button" className={s.button} disabled={busy} onClick={onClose}><X size={14} aria-hidden="true" />{tr('Отмена')}</button>
        <button type="submit" className={s.primary} disabled={busy || !valid}>{changingInn && <Save size={14} aria-hidden="true" />}{tr(changingInn ? 'Сохранить ИНН' : 'Сбросить PIN')}</button>
      </div>
    </form>
  </div>
}
